export default {
  "b2b.doplnkova-sluzba-editace-form.field.nazevCs.label": "Name CS",
  "b2b.doplnkova-sluzba-editace-form.field.nazevEn.label": "Name EN",
  "b2b.doplnkova-sluzba-editace-form.field.popisCs.label": "Description CS",
  "b2b.doplnkova-sluzba-editace-form.field.popisEn.label": "Description EN",
  "b2b.doplnkova-sluzba-editace-form.field.zkratka.label": "Abbreviation",
  "b2b.doplnkova-sluzba-editace-form.field.uzivaNapajeni.label":
    "It uses power",
  "b2b.doplnkova-sluzba-editace-form.field.vylucny.label": "Exclusive",
  "b2b.doplnkova-sluzba-editace-form.field.parkovani.label": "Parking",
  "b2b.doplnkova-sluzba-editace-form.field.bezCasu.label": "Without time",
  "b2b.doplnkova-sluzba-editace-form.field.platnostOd.label": "Validity from",
  "b2b.doplnkova-sluzba-editace-form.button.delete": "Delete",
  "b2b.doplnkova-sluzba-editace-form.button.submit": "Save",
  "b2b.doplnkova-sluzba-editace-form.button.cancel": "Cancel",
  "b2b.doplnkova-sluzba-editace-widget.titleNew": "New supplementary service",
  "b2b.doplnkova-sluzba-editace-form.save-dialog.title":
    "Saving supplementary service",
  "b2b.doplnkova-sluzba-editace-form.delete-dialog.title":
    "Deleting supplementary service"
};
